export default __webpack_public_path__ + "static/media/1BHK S 856,93.db2560e1.jpeg";